/** Colours shared by the 3-D scene and the CSS accents. */
export const SKY_TOP = "#285f77";
export const SKY_HORIZON = "#c7e0d4";
export const SKY_BOTTOM = "#e9f1df";
export const FOG_COLOR = "#c7e0d4";
export const SUN_COLOR = "#fff2cb";

export const GROUND_INNER = "#527f58";
export const GROUND_MID = "#3d6b4b";
export const GROUND_OUTER = "#305b41";
export const GROUND_FAR = "#274a36";

export const ROAD_COLOR = "#464c54";
export const ROAD_MARKING = "#ded9c2";
export const START_GATE = "#1b2a24";
export const TREE_TRUNK = "#5a4431";
export const TREE_GREENS = ["#2f6b45", "#3b7a4d", "#27593b"] as const;

export const HILL_GREENS = ["#2a5741", "#25503d", "#315e46", "#1f4635"] as const;

/** 24 distinct low-poly kits; kit ids arrive as a u8 on the wire. */
export const KIT_COLORS = [
  "#ef6c4d",
  "#f2b544",
  "#59b8dd",
  "#93cf5a",
  "#d87bd4",
  "#f1ead9",
  "#e55353",
  "#3f8ee0",
  "#7ed6c2",
  "#f2a65a",
  "#b6e06a",
  "#b596f2",
  "#ff8fb1",
  "#77c6ff",
  "#fed37a",
  "#b6d9a1",
  "#d96f9b",
  "#5fa78a",
  "#e9a23b",
  "#8e9df0",
  "#f4f4f4",
  "#64c7a8",
  "#cf5c3f",
  "#9ac3e8",
] as const;

export const SELF_ACCENT = "#dcff5a";
